module.exports = Object.freeze({
    DeleteRevenueSplitOptions: {
        KEEP_SPLIT_PERCENTAGE: 1,
        SET_SPLIT_100_PERCENTAGE: 2,
        SET_SPLIT_0_PERCENTAGE: 3
    }
});